/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { fetchLessons, fetchLesson, updateLesson } from './action';

export const lessonsSlice = createSlice({
  name: 'lesson',
  initialState: {
    lessons: [],
    lesson: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearLessons: (state) => {
      state.lessons = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLessons.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchLessons.fulfilled, (state, action) => {
        state.lessons = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchLessons.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchLesson.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchLesson.fulfilled, (state, action) => {
        state.lesson = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchLesson.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(updateLesson.fulfilled, (state, action) => {
        state.lesson = action.payload;
      });
  },
});
export const { clearLessons } = lessonsSlice.actions;

export default lessonsSlice.reducer;
